/*
 * The module for cancelling a tender
 */
var TECL_TenderCancelModule = {

  /*
   * Method used to initialise the cancellation process
   */
  Initialise: function() {

    // Handle when a tender cancel button is clicked
    $("body").on("click", ".tenderCancelLink", function () {
      var $cancelElement = $(this);
      var tenderId = $cancelElement.attr("data-tenderId");
      var $modal = $("#tenderCancelDialog");
      $modal.attr("data-tenderId", tenderId);
      $modal.find(".btn-ok").addClass("hidden");
      $modal.find(".modal-body").html($("#tenderCancelDialogContent").html());
      $modal.modal("show");
    });

    // Handle when a cancellation option is clicked
    $("body").on("click", ".tender-cancellation-option", function () {
      var $cancelOption = $(this);
      var reason = $cancelOption.attr("data-reason");
      var $modal = $("#tenderCancelDialog");
      var $page1 = $modal.find(".tenderCancelPage1");
      var $page2 = $modal.find(".tenderCancelPage2");
      $page2.attr("data-reason", reason);

      $page1.slideToggle({
        duration: 300,
        start: function () {
          $page2.removeClass("hidden");
          $page2.slideToggle(0);
          $page2.slideToggle(300, function () {
            $("#tenderCancelDialog .btn-ok").removeClass("hidden");
          });
        }
      });
    });

    // Handle when the cancellation submit is clicked
    $("body").on("click", "#tenderCancelDialog .btn-ok", function () {
      var $modal = $("#tenderCancelDialog");
      var $page2 = $modal.find(".tenderCancelPage2");
      var reason = $page2.attr("data-reason");
      var extraDetails = $page2.find("textarea[name='tenderCancelExtraInfo']").val();

      var ajaxLockKey = "TenderSupplierSelect_CancelTender";

      if (TECL_Master.AddLock(ajaxLockKey)) {

        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/CancelTender",
          dataType: "json",
          type: "POST",
          data: {
            tenderId: $modal.attr("data-tenderId"),
            reason: reason,
            extraDetails: extraDetails
          },
          error: function (exc) {
            TECL_Master.ClearLock(ajaxLockKey);
            TECL_Master.ShowErrorDialog("Failed to cancel project");
          },
          success: function (result) {
            TECL_Master.ClearLock(ajaxLockKey);

            if (result.ResultData) {
              window.location.reload();
            } else {
              TECL_Master.ShowErrorDialog(result.ErrorMessage);
            }
          }
        });
      }
    });
  }

}